import { Radio as RadioA } from 'antd';
import cs from 'classnames';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { resolveClassNames } from '../utils';
import styles from './radio.module.css';

type P = ComponentProps<typeof RadioA>;

const Radio = ({ children, classNames, ...rest }: P) => {
  const { t } = useTranslation();

  return (
    <RadioA
      {...rest}
      classNames={resolveClassNames(classNames, (resolvedClassNames) => ({
        ...resolvedClassNames,
        icon: cs(styles.icon, resolvedClassNames?.icon),
        label: cs(styles.label, resolvedClassNames?.label),
        root: cs(styles.radio, resolvedClassNames?.root),
      }))}
    >
      {typeof children === 'string' ? t(children) : children}
    </RadioA>
  );
};

export default Radio;
